module.exports = __webpack_public_path__ + "static/web-services-banner-e9f66bc3c96e964d1d0d1089c6662c04.jpg";